import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"


import { useI18n } from 'vue-i18n'
const __default__ = { name: 'CosModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  hideOk: {
    type: Boolean,
    default: false
  },
  okText: {
    type: String
  },
  cancelText: {
    type: String
  },
  confirmLoading: {
    type: Boolean,
    default: false
  }
},
  emits: ['ok', 'cancel', 'update:visible'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()


const emit = __emit
const submit = () => {
  emit('ok')
}
const cancael = () => {
  emit('cancel')
  emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_DcPenetrateContent = _resolveComponent("DcPenetrateContent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, _mergeProps(_ctx.$attrs, { onCancel: cancael }), {
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        _createVNode(_component_a_button, { onClick: cancael }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.cancelText || _unref(t)('btn.cancel')), 1)
          ]),
          _: 1
        }),
        (!__props.hideOk)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              loading: __props.confirmLoading,
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.okText || _unref(t)('btn.confirm')), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DcPenetrateContent, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16))
}
}

})